/**
 * Accessory page hero (sections/sunday-a-hero.liquid): the "Finish the bed" tiles show each accessory's
 * price at the size chosen in the buy box (sunday:abuy), so the three prices always match one bed.
 * A choices-only accessory (the pillow) keeps its own first price; the page's own tile shows its price.
 * Also: the pillow demo's closing line, from the demo section's setting; and the photos under the main
 * photo: a tap shows that photo (or plays that film) in the main frame.
 */
import { money } from '@sunday/util';
const RX = /(\d+)\s*["″]?\s*[x×]\s*(\d+)/;
if (!window.__sdATiles) {
  window.__sdATiles = true;
  document.addEventListener('sunday:abuy', (e) => {
    const d = e.detail || {};
    document.querySelectorAll('[data-tiles] .sd-at').forEach((a) => {
      const out = a.querySelector('[data-tile-price]');
      if (Number(a.dataset.product) === Number(d.productId)) {
        out.textContent = money(d.price);
        return;
      }
      if (!d.w) return;
      let vs = [];
      try {
        vs = JSON.parse(a.querySelector('script[type="application/json"]').textContent);
      } catch (x) {}
      const v = vs.find(([, t]) => {
        const m = RX.exec(t || '');
        return m && Number(m[1]) === d.w && Number(m[2]) === d.l;
      });
      if (v) out.textContent = money(v[2]);
    });
  });
}

/* Pillow demo: the line under it is the demo section's setting (sections/sunday-a-demo.liquid). */
document.querySelectorAll('[data-pillow-foot]').forEach((sec) => {
  const say = sec.dataset.pillowFoot;
  const fix = () => {
    const p = sec.querySelector('.sd-pillw p.sd-xs.sd-mut:last-child');
    if (p && p.textContent !== say) p.textContent = say;
  };
  new MutationObserver(fix).observe(sec, { childList: true, subtree: true });
  fix();
});

/* Photos under the main photo. */
document.querySelectorAll('[data-agal]').forEach((g) => {
  if (g.dataset.on) return;
  g.dataset.on = '1';
  const fig = g.parentElement.querySelector('[data-agal-main]');
  const img = fig && fig.querySelector('img');
  if (!img) return;
  g.addEventListener('click', (e) => {
    const b = e.target.closest('.sd-agt');
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    g.querySelectorAll('.sd-agt').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    fig.dataset.fit = b.dataset.fit || '';
    const tpl = b.querySelector('template');
    if (tpl) {
      fig.replaceChildren(tpl.content.cloneNode(true));
      const v = fig.querySelector('video');
      if (v) v.play().catch(() => {});
      return;
    }
    img.srcset = b.dataset.srcset || '';
    img.src = b.dataset.src;
    img.alt = b.getAttribute('aria-label') || '';
    if (!fig.contains(img)) fig.replaceChildren(img);
  });
});
